var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import React from 'react';
import Icon from '../Icon';

/*eslint-disable */
var Stop = function Stop(props) {
  return React.createElement(
    Icon,
    _extends({ viewBox: '0 0 14 14' }, props),
    React.createElement(
      'g',
      null,
      React.createElement(
        'title',
        null,
        'Terminate'
      ),
      React.createElement(
        'g',
        { fill: 'currentColor', fillRule: 'evenodd' },
        React.createElement('path', { d: 'M4.586 3.879l-.707.707 5.535 5.536.708-.707z' }),
        React.createElement('path', { d: 'M9.414 3.879L3.878 9.415l.708.707 5.535-5.536z' }),
        React.createElement('path', { d: 'M7 0a7 7 0 1 0 0 14A7 7 0 0 0 7 0m0 1c3.308 0 6 2.692 6 6s-2.692 6-6 6-6-2.692-6-6 2.692-6 6-6' })
      )
    )
  );
};
/*eslint-enable */

export default Stop;
//# sourceMappingURL=Stop.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/Icons/dist/components/Stop.js